export default {
  name: 'groupsPlaceUtils',
  capitalize: function (value) {
    if (!value) return ''
    value = value.toString()
    if (value == 'rsvp') return 'RSVP'
    let ret = ""
    let parts = value.split(" ")
    for (let i=0; i<parts.length; i++) {
      if (i>0) ret += " "
      ret += parts[i].charAt(0).toUpperCase() + parts[i].slice(1)
    }
    return ret
  }
};
